import React, { useState } from "react";

import SearchForm from "@components/SearchForm/SearchForm";

import HeaderLogoStripe from "./HeaderLogoStripe";

type Props = {
  hideSearchForm?: boolean;
  nonce?: string;
  showCondensedHeaderLogoStripe?: boolean;
};

function Header({
  hideSearchForm,
  nonce,
  showCondensedHeaderLogoStripe,
}: Props) {
  const [isStaticHeaderLoaded, setIsStaticHeaderLoaded] = useState(false);

  return (
    <div
      className={`header${
        isStaticHeaderLoaded ? " header--static-header" : ""
      }`}
    >
      <HeaderLogoStripe
        isStaticHeaderLoaded={isStaticHeaderLoaded}
        nonce={nonce}
        onStaticHeaderLoadChange={setIsStaticHeaderLoaded}
        showCondensedHeaderLogoStripe={showCondensedHeaderLogoStripe}
      />
      {hideSearchForm !== true && (
        <div className="container">
          <SearchForm />
        </div>
      )}
    </div>
  );
}

export default Header;
